var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 17,
    viewBox: "0 0 99 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33136 0.294556L10.1136 5.7797H15.881L11.2151 9.1697L12.9973 14.6548L8.33136 11.2648L3.66542 14.6548L5.44765 9.1697L0.78171 5.7797H6.54913L8.33136 0.294556Z",
    fill: "#FF7A5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9709 0.294556L30.7531 5.7797H36.5205L31.8546 9.1697L33.6368 14.6548L28.9709 11.2648L24.3049 14.6548L26.0872 9.1697L21.4212 5.7797H27.1887L28.9709 0.294556Z",
    fill: "#FF7A5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6102 0.294556L51.3924 5.7797H57.1598L52.4939 9.1697L54.2761 14.6548L49.6102 11.2648L44.9442 14.6548L46.7265 9.1697L42.0605 5.7797H47.8279L49.6102 0.294556Z",
    fill: "#FF7A5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2495 0.294556L72.0317 5.7797H77.7991L73.1332 9.1697L74.9154 14.6548L70.2495 11.2648L65.5835 14.6548L67.3657 9.1697L62.6998 5.7797H68.4672L70.2495 0.294556Z",
    fill: "#FF7A5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8889 0.294556L92.6711 5.7797H98.4385L93.7726 9.1697L95.5548 14.6548L90.8889 11.2648L86.2229 14.6548L88.0051 9.1697L83.3392 5.7797H89.1066L90.8889 0.294556Z",
    fill: "#FF7A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.2ea291c6e4e4bcec6d365667d5121db2.svg";
export { ForwardRef as ReactComponent };